import { SvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

/**
 * Unchecked-state checkbox outline icon for the striped variant.
 *
 * Matches the bounding box of MDI's `CheckboxBlankOutline` (rounded rect from
 * 3,3 to 21,21 with rx=2) so the unchecked striped checkbox visually aligns
 * with the regular and dashed variants in the legend.
 */
export const CheckboxStripedOutlineIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none">
        <rect
          x="3"
          y="3"
          width="18"
          height="18"
          rx="2"
          stroke="currentColor"
          fill="none"
          strokeLinejoin="round"
          strokeDasharray="2 2"
        />
      </svg>
    </SvgIcon>
  );
};
